const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
const teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
const scales = ['', 'thousand', 'million', 'billion', 'trillion'];

function toWords(num) {
  if (num === 0) return '';
  if (num < 10) return ones[num];
  if (num < 20) return teens[num - 10];
  if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? '-' + ones[num % 10] : '');
  if (num < 1000) return ones[Math.floor(num / 100)] + ' hundred' + (num % 100 !== 0 ? ' and ' + toWords(num % 100) : '');
  
  for (let i = scales.length - 1; i > 0; i--) {
    let scaleValue = Math.pow(1000, i);
    if (num >= scaleValue) {
      return toWords(Math.floor(num / scaleValue)) + ' ' + scales[i] + (num % scaleValue !== 0 ? ', ' + toWords(num % scaleValue) : '');
    }
  }
}

export const convertToEnglish = (num, isBritish = false) => {
  if (isNaN(num)) return 'Waiting...';
  
  const absNum = Math.abs(num);
  const dollars = Math.floor(absNum);
  const cents = Math.round((absNum - dollars) * 100);
  
  let result = dollars === 0 ? 'Zero' : toWords(dollars);
  result = result.charAt(0).toUpperCase() + result.slice(1);
  
  const currency = "Dollars"; // 可根據需要動態調整
  
  if (cents === 0) {
    return `${result} ${currency} Only`;
  } else {
    // 支票標準寫法：and 50/100
    return `${result} ${currency} and ${cents.toString().padStart(2, '0')}/100 Only`;
  }
};